export const getAppealDetailPath = (id: number) =>
  `/conduct/appeals/view/${id}?exclude_never_activated=true&paginated=true`
